// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-navigation-entry-wrapper.active[data-v-bccaf5b6] .app-navigation-entry{background-color:var(--color-primary-element-light) !important}`, "",{"version":3,"sources":["webpack://./src/components/CategoriesList.vue"],"names":[],"mappings":"AACA,4EACC,8DAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
